const routes = [
  {
    path: '/blackSeries/twoPage/report',
    name: '黑色系专题报告',
    component: () => import('@/views/other/blackSeries/report'),
  },
  {
    path: '/chemicalSeries/twoPage/report',
    name: '黑色系专题报告',
    component: () => import('@/views/other/chemicalSeries/report'),
  },
]
export default routes
